import { useEffect } from 'react'
import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export function useCinemaTimeline(enabled = true, dependencyKey = '') {
  useEffect(() => {
    if (!enabled) return undefined

    gsap.registerPlugin(ScrollTrigger)

    const lenis = new Lenis({
      lerp: 0.08,
      smoothWheel: true,
      wheelMultiplier: 0.88,
    })
    let rafId = 0

    lenis.on('scroll', ScrollTrigger.update)

    const raf = (time) => {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    const contexts = []
    contexts.push(
      gsap.context(() => {
        gsap.utils.toArray('[data-reveal]').forEach((element) => {
          gsap.fromTo(
            element,
            { yPercent: 32, opacity: 0, clipPath: 'inset(28% 0 0 0)' },
            {
              yPercent: 0,
              opacity: 1,
              clipPath: 'inset(0% 0 0 0)',
              duration: 1.1,
              ease: 'power4.out',
              scrollTrigger: {
                trigger: element,
                start: 'top 82%',
                end: 'top 52%',
                scrub: 0.55,
              },
            },
          )
        })

        gsap.utils.toArray('[data-scrub]').forEach((element) => {
          gsap.fromTo(
            element,
            { '--scrub-progress': 0 },
            {
              '--scrub-progress': 1,
              ease: 'none',
              scrollTrigger: {
                trigger: element,
                start: 'top 88%',
                end: 'bottom 36%',
                scrub: true,
              },
            },
          )
        })

        const rail = document.querySelector('[data-capability-rail]')
        const track = document.querySelector('[data-capability-track]')
        if (rail && track && track.scrollWidth > window.innerWidth) {
          const distance = Math.max(0, track.scrollWidth - rail.clientWidth)
          gsap.to(track, {
            x: -distance,
            ease: 'none',
            scrollTrigger: {
              trigger: rail,
              pin: true,
              scrub: 0.8,
              start: 'top top',
              end: () => `+=${distance + window.innerHeight * 0.65}`,
              invalidateOnRefresh: true,
            },
          })
        }
      }),
    )

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
      contexts.forEach((context) => context.revert())
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
  }, [enabled, dependencyKey])
}
